import * as React from "react";
import { Input, Icon } from "antd";
import PbrDocUploader from "src/components/common/PbrDocUploaderTradeId/PbrDocUploader";
import { useState } from "react";
import "./ConfirmModalBody.scss";
import IApproveFileS3 from '../IApproveFileS3';

const ConfirmModalBody = props => {
  const [file, setFile] = useState<IApproveFileS3>(null);
  return (
    !props.hideInput && (
      <React.Fragment>
        <Input.TextArea onChange={e => props.onDescriptionChange(e.target.value)} placeholder={props.descriptionPlaceholder} autosize={{ minRows: 2, maxRows: 6 }} />

        <div className="container__upload">
          <div className="upload_button">
            <PbrDocUploader
              onChangeBase64={val => {
                const updatedFile = { file: val.file, fileName: val.name };
                props.onFileSend(updatedFile);
                setFile(updatedFile);
              }}
              hoverText="Upload File"
            />
          </div>
          <div className="label_file_name">
            <span>{file ? file.fileName : ""}</span>
          </div>

          {file && (
            <div
              className="delete_button"
              onClick={() => {
                props.onFileSend(null), setFile(null);
              }}
            >
              <Icon type="close" />
            </div>
          )}
        </div>
      </React.Fragment>
    )
  );
};

export default ConfirmModalBody;



// WEBPACK FOOTER //
// ./src/components/Refatoracao/ConfirmModalBody/ConfirmModalBody.tsx